var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9705 4.94664L15.9965 0.904872C15.7314 0.331787 15.1716 0 14.5529 0H4.4766C3.85789 0 3.29809 0.361949 3.03293 0.904872L1.05893 4.94664C1.02946 5.00696 1 5.09745 1 5.15777V10.7378C1 11.9745 2.00173 13 3.20971 13H15.7903C16.9983 13 18 11.9745 18 10.7378V5.12761C18 5.06729 18 5.00696 17.9705 4.94664ZM15.7903 12.0951H3.23917C2.5026 12.0951 1.91334 11.4919 1.91334 10.7378V5.58005H5.7435C6.00867 6.39443 6.95147 8.53596 9.51473 8.53596C12.078 8.53596 13.0208 6.39443 13.286 5.58005H17.1161V10.7077C17.1161 11.4919 16.5269 12.0951 15.7903 12.0951ZM4.4766 0.87471H14.5234C14.818 0.87471 15.0537 1.02552 15.1716 1.29698L16.851 4.67517H12.9619C12.7556 4.67517 12.5789 4.82599 12.5199 5.03712C12.4905 5.12761 11.9896 7.63109 9.51473 7.63109C7.03986 7.63109 6.50953 5.15777 6.50953 5.03712C6.45061 4.85615 6.27383 4.67517 6.06759 4.67517H2.17851L3.82842 1.29698C3.94627 1.05568 4.21144 0.87471 4.4766 0.87471Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.3231f70b506ff48a688ec8111ecfd43c.svg";
export { ForwardRef as ReactComponent };